// extracted by mini-css-extract-plugin
export default {"tab":"TabBar_tab__CM0Sl","tabItem":"TabBar_tabItem__lafAW","tabActive":"TabBar_tabActive__JdoGF","hideOnPhone":"TabBar_hideOnPhone__88pbL"};